export * from '../../shared/stickers';

export const stickerUrl = (id: string) => `/stickers/${id}.webp`;
